import RequiredSign from "@components/common/ui-elements/required-sign";
import DropDown from "@components/common/form-controls/drop-down";
import React from "react";
import uuid4 from "@utils/uuid4";
import {isPlainObject} from "@utils/object";
import {generateIdFromName} from "../../../../utils/string";
import {isDetailsMode, isEditableMode, useFormMode} from "@contexts/FormModeContext";
import {addUniqueCssClasses} from "@functions/css";

export default function ScrollableDropdownBlock(
   {
      containerCssClass = 'col-12 py-3',
      dataBlock = '',
      required = false,
      options = [],
      selectedValues = [],
      onChange,
      helpText = '',
      controlId = '',
      controlName = '',
      controlAttrs = {},
      labelText = 'Control Label',
      disabled = false,
      labelCssClass = ''
   }
) {
   
   const {mode} = useFormMode();
   
   let selectedValuesFormatted = '';
   
   if(isDetailsMode(mode)) {
      
      if(Array.isArray(selectedValues)) {
         selectedValuesFormatted = selectedValues.join(', ');
      } else if(isPlainObject(selectedValues)) {
         selectedValuesFormatted = '-';
      } else {
         selectedValuesFormatted = selectedValues;
      }
      
   }
   
   let paramError = '';
   
   
   // region [Additional Css Class]
   
   if (typeof containerCssClass === 'string') {
      containerCssClass += ' scrollable';
   } else if (Array.isArray(containerCssClass)) {
      
      containerCssClass = (containerCssClass.join(' ')) + ' scrollable';
      
   } else {
      containerCssClass = 'scrollable';
   }
   
   if(isDetailsMode(mode)) {
      containerCssClass += ' details-mode';
   }
   
   // endregion
   
   // region [Control Name]
   
   if (typeof controlName !== 'string') {
      
      paramError = ("Control name for dropdown must be a string data type");
      
   } else if (controlName.trim() === '') {
      paramError = ("Control name for dropdown cannot be empty");
   }
   
   controlAttrs.name = controlName;
   
   // endregion
   
   // region [Control Attrs]
   
   if (!isPlainObject(controlAttrs)) {
      controlAttrs = {};
   }
   
   delete controlAttrs.name;
   
   if(disabled) {
      controlAttrs.disabled = true;
   } else {
      delete controlAttrs.disabled;
   }
   
   // endregion
   
   // region [Label Text]
   
   if (typeof labelText !== 'string') {
      labelText = '';
   } else {
      labelText = labelText.trim();
   }
   
   // endregion
   
   // region [Control ID]
   
   if (typeof controlId !== 'string' || controlId.trim() === '') {
      controlId = generateIdFromName(controlName);
   }
   
   // endregion
   
   // region [Data Block]
   
   if (typeof dataBlock !== 'string' || dataBlock.trim() === '') {
      dataBlock = controlName;
   }
   
   // endregion
   
   labelCssClass = addUniqueCssClasses(labelCssClass, 'form-label');
   
   return (
      <div className={containerCssClass} data-block={dataBlock}>
         {labelText !== '' && (
            <label
               htmlFor={controlId}
               className={labelCssClass}>
               {labelText} <RequiredSign required={required} />
            </label>
         )}
         
         {isEditableMode(mode) && (
            <>
               {paramError !== '' && (
                  <p className="text-danger">{paramError}</p>
               )}
               
               {paramError === '' && (
                  <DropDown
                     id={controlId}
                     selectedValues={selectedValues}
                     options={options}
                     name={controlName}
                     className="form-select"
                     required={required}
                     onChange={onChange}
                     {...controlAttrs}
                  />
               
               )}
               
               
               {helpText !== '' && (
                  <div className="form-text mt-2">
                     {helpText}
                  </div>
               )}
            </>
         )}
         
         {isDetailsMode(mode) && (
            <>
               <div className="form-text">
                  
                  {selectedValuesFormatted}
                  
               </div>
            </>
         )}
         
         
         {isEditableMode(mode) && process.env.NEXT_PUBLIC_DISPLAY_CONTROL_NAMES === "1" && (
            <div className="mt-3 d-flex flex-column gap-3" style={{width: 'fit-content'}}>
               
               <p className="m-0 p-3 text-danger badge bg-primary-subtle fs-6 text-break">
                  {controlName}
               </p>
               
               <p className="m-0 p-3 text-black badge bg-success-subtle fs-6 text-break">
                  {dataBlock}
               </p>
            
            </div>
         )}
      
      </div>
   );
   
}